// Source unique de vérité pour les statuts de série.
// Backend : enum dans BedethequeModel.statutSerie. Front : libellés et options Mantine.

export const STATUT_SERIE_LABELS = {
    finie: 'Série finie',
    oneshot: 'One shot',
    suspendue: 'Série suspendue',
}

export const STATUT_SERIE_OPTIONS = Object.entries(STATUT_SERIE_LABELS).map(
    ([value, label]) => ({ value, label })
)
